import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const VersionsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  margin-left: 0;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow:
    0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  overflow-x: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;


export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(20)};
  align-items: center;
`;


export const IconsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(8)};
`;

export const Icon = styled.img`
  width: ${pxToRem(46)};
  height: ${pxToRem(46)};
  transition: all 0.5s ease;

  &:hover {
    transform: translateY(${pxToRem(-3)});
  }
`;

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ExternalLinkButton = styled.button`
  padding: ${pxToRem(16.8)} ${pxToRem(33.6)};
  border: none;
  border-radius: ${pxToRem(14.4)};
  background: rgb(114, 82, 220);
  color: rgb(255, 255, 255);
  font-size: ${pxToRem(21.6)};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: #603cbc;
    transform: translateY(-2px);
  }
  
  &:active {
    transform: translateY(-1px);
  }
`;